import CanteenAuth          from 'alto-react-canteen/lib/auth_client'
import ClientAuthRepository from 'alto-react-client-auth/lib/models'

import config from './config'

auth            = new CanteenAuth(config.backendUrl, config.frontendUrl)
auth.repository = ClientAuthRepository.for(config.backendUrl, auth)

export default auth
